export const CHAINID_URL_MAPPING = [{
    chainId: 1,
    chainName: 'ETH',
    urlChainName: 'eth',
    name: 'Etherscan',
    currency: 'ETH',
    url: 'https://etherscan.com/',
    dex: 'https://app.uniswap.org/#/swap',
    wssRPC: "wss://speedy-nodes-nyc.moralis.io/6196a9a5be4a0a7facda19a7/eth/mainnet/ws",
    httpRPC: "https://speedy-nodes-nyc.moralis.io/6196a9a5be4a0a7facda19a7/eth/mainnet",
    blockTime: 13.2,
}, {
    chainId: 3,
    chainName: 'ETH Testnet',
    urlChainName: 'rop',
    name: 'Etherscan',
    currency: 'ETH',
    url: 'https://ropsten.etherscan.io/',
    dex: 'https://app.uniswap.org/#/swap',
    wssRPC: "wss://speedy-nodes-nyc.moralis.io/6196a9a5be4a0a7facda19a7/eth/ropsten/ws",
    httpRPC: "https://speedy-nodes-nyc.moralis.io/6196a9a5be4a0a7facda19a7/eth/mainnet",
    blockTime: 13.2,
}, {
    chainId: 97,
    chainName: 'BSC Testnet',
    urlChainName: 'tbsc',
    name: 'Bscscan',
    currency: 'BNB',
    url: 'https://testnet.bscscan.com/',
    dex: 'https://pancakeswap.finance/',
    wssRPC: "",
    httpRPC: "https://data-seed-prebsc-1-s1.binance.org:8545/",
    blockTime: 3,
}, {
    chainId: 56,
    chainName: 'BSC',
    urlChainName: 'bsc',
    name: 'Bscscan',
    currency: 'BNB',
    url: 'https://bscscan.com/',
    dex: 'https://pancakeswap.finance/',
    wssRPC: "",
    httpRPC: "https://bscrpc.com",
    blockTime: 3,
}, {
    chainId: 321,
    chainName: 'KCC',
    urlChainName: 'kcc',
    name: 'Scan',
    currency: 'KCC',
    url: 'https://scan.kcc.network/',
    dex: '',
    wssRPC: "",
    httpRPC: "",
    blockTime: 1,
}, {
    chainId: 322,
    chainName: 'KCC Testnet',
    urlChainName: 'tkcc',
    name: 'Scan',
    currency: 'KCC',
    url: 'https://scan-testnet.kcc.network/',
    dex: '',
    wssRPC: "",
    httpRPC: "",
    blockTime: 1,
}, {
    chainId: 137,
    chainName: 'Polygon',
    urlChainName: 'polygon',
    name: 'Polygonscan',
    currency: 'MATIC',
    url: 'https://polygonscan.com/',
    dex: 'https://quickswap.exchange/',
    wssRPC: "",
    httpRPC: "https://polygon-rpc.com/",
    blockTime: 2.2,
}, {
    chainId: 80001,
    chainName: 'Polygon Testnet',
    urlChainName: 'tpolygon',
    name: 'Polygonscan',
    currency: 'MATIC',
    url: 'https://mumbai.polygonscan.com/',
    dex: 'https://quickswap.exchange/',
    wssRPC: "wss://speedy-nodes-nyc.moralis.io/6196a9a5be4a0a7facda19a7/polygon/mumbai/ws",
    httpRPC: "https://speedy-nodes-nyc.moralis.io/6196a9a5be4a0a7facda19a7/polygon/mumbai",
    blockTime: 2.2,
}]

export const MINIMUM_LOCK = 1209600

export const MINIMUM_STAKE = 50